<template>
    <div>
        <div class="fsc">
            <span class="lines"></span>
            <span class="fawer_text" @click="onClick()">{{contTitle}}</span>
			<span v-if="obj.backer == true"  class="fawer_cler" @click="onClick()">返回</span>
            <span v-if="obj.hide == true" class="fawer_price">共计:100元</span>
            <span v-if="obj.isShow == true"  :class="[obj.contCount ==''?'dn':'unread']">({{obj.contCount}})</span>
        </div>
    </div>
</template>
<script>
export default {
   props:["obj","contTitle"],
   methods:{
	  onClick(){
		this.$emit('onBacker')
	  }
   }
}
</script>
<style scoped>
.fawer_price{
    margin-left: 20px;
    font-size: 14px;
}
.dn{
    display: none;
}
.fawer_cler{
  font-size: 12px;
  margin-left: 15px;
  margin-top: 3px;
}
.fawer_cler:hover{
   cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/common/contTitle.vue